import React from "react";
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: "20px 3.175%"
}));


export const ContentLayout: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <>
            <StyledBox>
                {props.children}
            </StyledBox>
        </>
    );
}
